import type { PostPipeline } from '../render/types';
import { isRenderable } from './resizeDecision';

/* WHY wrap here rather than change frameLoop.ts: the loop always calls pipeline.render once per
   tick so it keeps ticking, and so keeps retrying, while the canvas is empty; skipping the draw
   itself, rather than the tick, is what avoids a draw call against render targets sized for a
   canvas that currently has no box, without the loop itself needing to know why. */
export function skipRenderWhenEmpty(
  pipeline: PostPipeline,
  canvas: HTMLCanvasElement
): PostPipeline {
  return {
    annotations: pipeline.annotations,
    ...(pipeline.painterHandoff ? { painterHandoff: pipeline.painterHandoff } : {}),
    setDaylight: (light) => {
      pipeline.setDaylight(light);
    },
    setNight: (frame) => {
      pipeline.setNight(frame);
    },
    setSize: (widthPx, heightPx) => {
      pipeline.setSize(widthPx, heightPx);
    },
    setQuality: (q) => {
      pipeline.setQuality(q);
    },
    compile: (scene, camera) => pipeline.compile(scene, camera),
    dispose: () => {
      pipeline.dispose();
    },
    get passCount(): number {
      return pipeline.passCount;
    },
    render(scene, camera) {
      if (isRenderable({ width: canvas.clientWidth, height: canvas.clientHeight })) {
        pipeline.render(scene, camera);
      }
    },
  };
}
